import IconAsMaskImage from "../IconAsMaskImage";

function OutlinedMicrophone({ pureSvg, className, color }) {
  const svg = (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.25 4.2832C7.69329 4.2832 4 7.97649 4 12.5332C4 17.089 7.69335 20.7832 12.25 20.7832C16.8067 20.7832 20.5 17.089 20.5 12.5332C20.5 7.97649 16.8067 4.2832 12.25 4.2832ZM2.5 12.5332C2.5 7.14807 6.86487 2.7832 12.25 2.7832C17.6351 2.7832 22 7.14807 22 12.5332C22 17.9173 17.6352 22.2832 12.25 22.2832C6.86481 22.2832 2.5 17.9173 2.5 12.5332Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.91406 14.2277C9.24247 13.9752 9.71333 14.0368 9.96576 14.3652C10.5428 15.116 11.3652 15.5541 12.2511 15.5541C12.6653 15.5541 13.0011 15.8899 13.0011 16.3041C13.0011 16.7184 12.6653 17.0541 12.2511 17.0541C10.8447 17.0541 9.60247 16.3539 8.7765 15.2794C8.52407 14.951 8.58566 14.4801 8.91406 14.2277Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.45696 10.2012C9.284 10.2012 9.1039 10.2854 8.9639 10.4676C8.71152 10.796 8.24067 10.8577 7.91222 10.6053C7.58377 10.353 7.52209 9.88212 7.77446 9.55367C8.16376 9.04701 8.76398 8.70117 9.45696 8.70117C10.1499 8.70117 10.7502 9.04701 11.1395 9.55367C11.3918 9.88212 11.3302 10.353 11.0017 10.6053C10.6733 10.8577 10.2024 10.796 9.95003 10.4676C9.81003 10.2854 9.62992 10.2012 9.45696 10.2012Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9247 10.2012C14.7518 10.2012 14.5717 10.2854 14.4317 10.4676C14.1793 10.796 13.7084 10.8577 13.38 10.6053C13.0515 10.353 12.9899 9.88212 13.2422 9.55367C13.6315 9.04701 14.2318 8.70117 14.9247 8.70117C15.6177 8.70117 16.2179 9.04701 16.6072 9.55367C16.8596 9.88212 16.7979 10.353 16.4695 10.6053C16.141 10.8577 15.6702 10.796 15.4178 10.4676C15.2778 10.2854 15.0977 10.2012 14.9247 10.2012Z"
        fill="white"
      />
    </svg>
  );

  if (pureSvg) return svg;

  return <IconAsMaskImage {...{ svg, className, color }} />;
}

export default OutlinedMicrophone;
